module.exports = __webpack_public_path__ + "static/sizzle-a4b6501c06fa78ecc404fa363dd727cf.mp4";